var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"text-body-2 font-weight-bold",class:{'text-right': _vm.right}},[_vm._v(_vm._s(_vm.label))]),_vm._t("default",function(){return [_c('span',{staticClass:"span-container"},[_vm._v(_vm._s(_vm.value))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }